import { append as append_1, ofArray, singleton as singleton_1, toArray, isEmpty, map, contains } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { equals, stringHash } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { paginationR, nothing, errorMsg, spinner, linkicon, newIndicator } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { toString } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import * as react from "react";
import { CollapsableElement } from "../../../../Bfs.Web.Portale/Collapsable.fs.js";
import { Http_downloadUrl } from "./State.fs.js";
import { DOMAttr, HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Page, Msg } from "./Types.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { Filter } from "../../../Kundenportal.Types.fs.js";
import { Option, ISize, column } from "../../../fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { Modifier_IModifier, Screen } from "../../../fable_modules/Fulma.3.0.0/Common.fs.js";
import { DropdownProps$1, bfsDropdown } from "../Shared/Dropdown.fs.js";

export function fileZeile(dispatch, expandedIds, file) {
    let children_6, children_8, children_12, props_10, children_10, children_16;
    const isExpanded = contains(file.Id, expandedIds, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    });
    const iconclass = isExpanded ? " upsidedown" : "";
    const children_18 = [(children_6 = toList(delay(() => append(file.IsNew ? singleton(newIndicator) : empty(), delay(() => {
        let children_2, children;
        return append(singleton((children_2 = [file.Titel, (children = [toString(file.Datum, "dd.MM.yyyy")], react.createElement("p", {
            className: "is-hidden-desktop",
        }, ...children))], react.createElement("div", {}, ...children_2))), delay(() => singleton(CollapsableElement([react.createElement("p", {}, file.Beschreibung), isExpanded]))));
    })))), react.createElement("td", {}, ...children_6)), (children_8 = [toString(file.Datum, "dd.MM.yyyy")], react.createElement("td", {
        className: "is-hidden-touch",
    }, ...children_8)), (children_12 = [(props_10 = [new HTMLAttr(94, [Http_downloadUrl(file)]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(5, [file.Id]));
    }])], (children_10 = [linkicon("fas fa-file-download")], react.createElement("a", keyValueList(props_10, 1), ...children_10)))], react.createElement("td", {
        className: "icon-column",
    }, ...children_12)), (children_16 = toList(delay(() => {
        let children_14;
        return (file.Beschreibung !== "") ? singleton((children_14 = [linkicon("fas fa-chevron-down" + iconclass)], react.createElement("a", {
            onClick: (_arg_1) => {
                dispatch(new Msg(4, [file.Id]));
            },
        }, ...children_14))) : empty();
    })), react.createElement("td", {
        className: "icon-column",
    }, ...children_16))];
    return react.createElement("tr", {}, ...children_18);
}

export function filesTabelle(fileList, expandedIds, dispatch) {
    let children_8, children_6, children_4, children_10;
    const children_12 = [(children_8 = [(children_6 = [react.createElement("th", {}, "Dokument"), (children_4 = [react.createElement("span", {
        className: "is-hidden-touch",
    }, "Bereitgestellt am")], react.createElement("th", {
        colSpan: 3,
    }, ...children_4))], react.createElement("tr", {}, ...children_6))], react.createElement("thead", {
        className: "is-hidden-touch",
    }, ...children_8)), (children_10 = map((file) => fileZeile(dispatch, expandedIds, file), fileList), react.createElement("tbody", {}, ...children_10))];
    return react.createElement("table", {
        className: "table table-striped responsive-table ",
    }, ...children_12);
}

export function filesBox(model, dispatch) {
    let children_4, children_2, children_6;
    const children_8 = [(children_4 = [(children_2 = [react.createElement("b", {}, "Ihre Dokumente")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_6 = toList(delay(() => {
        const matchValue = model.Files;
        return (matchValue.tag === 1) ? singleton(spinner) : ((matchValue.tag === 2) ? singleton(errorMsg("Ladefehler")) : ((matchValue.tag === 3) ? (isEmpty(matchValue.fields[0].Items) ? singleton(errorMsg("Keine Dokumente vorhanden.")) : singleton(filesTabelle(matchValue.fields[0].Items, model.ExpandedBeschreibungen, dispatch))) : singleton(nothing)));
    })), react.createElement("div", {
        className: "card-body",
    }, ...children_6))];
    return react.createElement("div", {
        className: "flat-card profile-info-card is-auto overflow-initial is-relative",
    }, ...children_8);
}

export function kategorie(name, navigateToFilter, currentFilter, navigateTo) {
    let children_2;
    const props_4 = [new HTMLAttr(65, [("wishlist-item " + (equals(navigateToFilter, currentFilter) ? " is-active" : "")) + (equals(navigateToFilter, new Filter(1, [])) ? " new-kategorie" : "")]), new DOMAttr(40, [(_arg) => {
        navigateTo(new Page(1, navigateToFilter));
    }])];
    const children_4 = [(children_2 = toList(delay(() => singleton(react.createElement("a", {}, name)))), react.createElement("div", {
        className: "item-wrapper",
    }, ...children_2))];
    return react.createElement("li", keyValueList(props_4, 1), ...children_4);
}

export function kategorien(model, dispatch, navigateTo) {
    let children_4, children_2;
    const children_6 = [(children_4 = [(children_2 = toList(delay(() => append(singleton(kategorie("Neue Dokumente", new Filter(1, []), model.SelectedFilter, navigateTo)), delay(() => append(singleton(kategorie("Alle Dokumente", new Filter(0, []), model.SelectedFilter, navigateTo)), delay(() => {
        const matchValue = model.Kategorien;
        return (matchValue.tag === 1) ? singleton(spinner) : ((matchValue.tag === 2) ? singleton(errorMsg("Ladefehler")) : ((matchValue.tag === 3) ? singleton(toArray(map((x) => kategorie(x, new Filter(2, [x]), model.SelectedFilter, navigateTo), matchValue.fields[0]))) : singleton(react.createElement("div", {}))));
    })))))), react.createElement("ul", {
        className: "wishlists",
    }, ...children_2))], react.createElement("div", {
        className: "flat-card is-auto menu-card is-relative overflow-initial",
    }, ...children_4))];
    return react.createElement("div", {
        className: "column is-4 is-hidden-touch",
    }, ...children_6);
}

export function kategorienMobile(model, dispatch, navigateTo) {
    return column(ofArray([new Option(0, [new Screen(0, []), new ISize(16, [])]), new Option(4, [singleton_1(new Modifier_IModifier(24, [new Screen(1, []), true]))])]), toList(delay(() => {
        const matchValue = model.Kategorien;
        switch (matchValue.tag) {
            case 1:
                return singleton(spinner);
            case 2:
                return singleton(errorMsg("Ladefehler"));
            case 3: {
                const categories = map((Item) => (new Filter(2, [Item])), matchValue.fields[0]);
                return singleton(bfsDropdown()(new DropdownProps$1(append_1(ofArray([new Filter(1, []), new Filter(0, [])]), categories), model.SelectedFilter, (filter_1) => ((filter_1.tag === 1) ? "Neue Dokumente" : ((filter_1.tag === 2) ? filter_1.fields[0] : "Alle Dokumente")), (filter) => {
                    switch (filter.tag) {
                        case 1:
                            return "NurNeue";
                        case 2:
                            return filter.fields[0];
                        default:
                            return "Alle";
                    }
                }, (filter_2) => {
                    navigateTo(new Page(1, filter_2));
                })));
            }
            default:
                return singleton(react.createElement("div", {}));
        }
    })));
}

export function view(model, dispatch, navigateTo) {
    const children = [kategorien(model, dispatch, (arg) => {
        navigateTo(arg);
    }), kategorienMobile(model, dispatch, (arg_1) => {
        navigateTo(arg_1);
    }), column(ofArray([new Option(0, [new Screen(1, []), new ISize(12, [])]), new Option(0, [new Screen(5, []), new ISize(16, [])])]), ofArray([filesBox(model, dispatch), paginationR(model.Files, (p) => {
        navigateTo(new Page(p, model.SelectedFilter));
    })]))];
    return react.createElement("div", {
        className: "columns is-account-grid is-multiline dokumente",
    }, ...children);
}

//# sourceMappingURL=View.fs.js.map
